module.exports = __webpack_public_path__ + "img/ny.3b3c95ca.png";